export const hybridSpaceErrorRetryTitle = "CBGtfe";
export const hybridSpaceErrorNotFoundMessage = "ebPlvb";
export const hybridSpaceErrorRetryActionButtonLabel = "_LU8re";
export const hybridSpaceErrorRetryImageAriaLabel = "SfDpXc";
export default {hybridSpaceErrorRetryTitle,hybridSpaceErrorNotFoundMessage,hybridSpaceErrorRetryActionButtonLabel,hybridSpaceErrorRetryImageAriaLabel};